import { LotteryDashboard } from "@/components/dashboard/lottery-dashboard";

export default function DashboardPage() {
  return <LotteryDashboard username="DEMO USER" userRole="user" />
}
